import '../styles/BetaTesting.scss';

import { Stack } from '@whistler-ui/k2/components/Stack';
import { Heading, Paragraph } from '@whistler-ui/k2/components/Typography';

import useRenderIf from '../../../hooks/useRenderIf';
import { useThemeStore } from '../../../store/theme';

const componentName = 'c-BetaTesting';

export function BetaTesting() {
  const { config } = useThemeStore();
  const { RenderIf } = useRenderIf();

  const image = config.assets.onboarding.betaTest;

  return (
    <Stack direction="row" gap={8} className={componentName}>
      <Stack direction="column" gap={8} tag="section">
        <Heading>Public Beta Testing</Heading>
        <Stack direction="column" gap={4}>
          <Paragraph>
            With your certification tests completed, we’ll let you know when the
            public Beta release is available with the configuration changes
            needed for your ES.
          </Paragraph>
          <Paragraph>
            You can run your own Business Acceptance Testing (BAT) using your
            own devices by joining the OEM’s Beta program. At this point, your
            service is considered live, and subscribers who install the public
            Beta release will be able to try out your new ES use cases.
          </Paragraph>
          <RenderIf ues={true}>
            <Paragraph>
              We'll provide you with a test plan to complete on your home
              network. The results will be shared with the relevant OEM(s) and
              represent the final gate before your service moves from public
              Beta into general availability.
            </Paragraph>
          </RenderIf>
        </Stack>
      </Stack>
      {image && (
        <aside>
          <img src={image} alt="Beta Testing" />
        </aside>
      )}
    </Stack>
  );
}
